import { render, staticRenderFns } from "./teams-settings-controller.vue?vue&type=template&id=39f3567a&"
import script from "./teams-settings-controller.vue?vue&type=script&lang=js&"
export * from "./teams-settings-controller.vue?vue&type=script&lang=js&"
import style0 from "./teams-settings-controller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports